module.exports = __webpack_public_path__ + "img/partner29.349efb03.png";